<template>
   <div class="main-wrapper">
      <div class="header-topbar">
         <div class="container">
            <div class="topbar-info">
               <div class="d-flex align-items-center gap-3 header-info">
                  <p><i class="isax isax-message-text5 me-1"></i><a href="javascript:void(0)"
                        class="__cf_email__">info@healthtechcanada.com</a></p>
                  <p><i class="isax isax-call5 me-1"></i>+1 66589 14556</p>
               </div>
               <ul>
                  <li class="header-theme">
                     <!-- <a href="javascript:void(0);" id="dark-mode-toggle" class="theme-toggle">
                        <i class="isax isax-sun-1"></i>
                     </a> -->
                     <!-- <a href="javascript:void(0);" id="light-mode-toggle" class="theme-toggle activate">
                        <i class="isax isax-moon"></i>
                     </a> -->
                  </li>
                  <li class="d-inline-flex align-items-center drop-header">
                     <div class="dropdown dropdown-country me-3">
                        <a href="javascript:void(0);" class="d-inline-flex align-items-center" data-bs-toggle="dropdown"
                           aria-expanded="false">
                           <img src="assets/img/flags/us-flag.svg" class="me-2" alt="flag">
                        </a>
                        <ul class="dropdown-menu p-2 mt-2">
                           <li>
                              <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                 <img src="assets/img/flags/us-flag.svg" class="me-2" alt="flag">ENG
                              </a>
                           </li>
                           <li>
                              <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                 <img src="assets/img/flags/arab-flag.svg" class="me-2" alt="flag">ARA
                              </a>
                           </li>
                           <li>
                              <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                 <img src="assets/img/flags/france-flag.svg" class="me-2" alt="flag">FRA
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="dropdown dropdown-amt">
                        <a href="javascript:void(0);" class="dropdown-toggle" data-bs-toggle="dropdown"
                           aria-expanded="false">
                           USD
                        </a>
                        <ul class="dropdown-menu p-2 mt-2">
                           <li><a class="dropdown-item rounded" href="javascript:void(0);">USD</a></li>
                           <li><a class="dropdown-item rounded" href="javascript:void(0);">YEN</a></li>
                           <li><a class="dropdown-item rounded" href="javascript:void(0);">EURO</a></li>
                        </ul>
                     </div>
                  </li>
                  <li class="social-header">
                     <div class="social-icon">
                        <a href="javascript:void(0);"><i class="fa-brands fa-facebook"></i></a>
                        <a href="javascript:void(0);"><i class="fa-brands fa-x-twitter"></i></a>
                        <a href="javascript:void(0);"><i class="fa-brands fa-instagram"></i></a>
                        <a href="javascript:void(0);"><i class="fa-brands fa-linkedin"></i></a>
                        <a href="javascript:void(0);"><i class="fa-brands fa-pinterest"></i></a>
                     </div>
                  </li>
               </ul>
            </div>
         </div>
      </div>
      <!-- Header -->
      <header class="header header-custom header-fixed inner-header fixed">
         <div class="container">
            <nav class="navbar navbar-expand-lg header-nav">
               <div class="navbar-header">
                  <a id="mobile_btn" href="javascript:void(0);">
                     <span class="bar-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                     </span>
                  </a>
                  <a href="javascript:void(0)" class="navbar-brand logo" v-on:click="GoTo('/')">
                     <img src="assets/img/web-01.png" class="img-fluid" width="80" alt="Logo">
                  </a>
               </div>
               <div class="header-menu">
                  <div class="main-menu-wrapper">
                     <div class="menu-header">
                        <a href="javascript:void(0)" class="menu-logo" v-on:click="GoTo('/')">
                           <img src="assets/img/web-01.png" width="80" class="img-fluid" alt="Logo">
                        </a>
                        <a id="menu_close" class="menu-close" href="javascript:void(0);">
                           <i class="fas fa-times"></i>
                        </a>
                     </div>
                     <ul class="main-nav d-block d-sm-none">

                        <!-- /Notifications -->

                        <li class="nav-item" v-if="!isUser">
                           <a href="javascript:void(0)" v-on:click="GoTo('/login')" class=""><i
                                 class="isax isax-lock-1 me-1"></i>Sign In</a>
                        </li>
                        <li class="nav-item" v-if="!isUser">
                           <a href="javascript:void(0) " @click="GoTo('/signup')" class="">
                              <i class="isax isax-user-tick me-1"></i>Register
                           </a>
                        </li>

                           <li class="nav-item" v-if="isUser">
                              <a class="" href="javascript:void(0)" v-if="roleName == 'Patient'"
                                 @click="GoTo('/dashboard')"> <i class="isax isax-category-2"></i>Dashboard</a>
                           </li>
                           <li class="nav-item" v-if="isUser">
                              <a class="" href="javascript:void(0)" v-if="roleName == 'Doctor'"
                                 @click="GoTo('/dashboard')"> <i class="isax isax-category-2"></i>Dashboard</a>
                           </li>
                           <li class="nav-item" v-if="isUser">
                              <a class="" href="javascript:void(0)" v-if="roleName == 'Patient'"
                                 @click="GoTo('/patientProfile')"><i class="isax isax-setting-2"></i>Profile Settings</a>
                           </li>
                           <li class="nav-item" v-if="isUser">
                              <a class="" href="javascript:void(0)" @click="logout()"><i class="fas fa-sign-out-alt"></i>Logout</a>
                           </li>

                     </ul>
                  </div>
                  <ul class="nav header-navbar-rht">
                     <!-- Notifications -->
                     <li class="nav-item dropdown noti-nav me-3 pe-0" v-if="isUser">
                        <a href="#" class="dropdown-toggle active-dot active-dot-danger nav-link p-0"
                           data-bs-toggle="dropdown">
                           <i class="isax isax-notification-bing"></i>
                        </a>
                        <div class="dropdown-menu notifications dropdown-menu-end ">
                           <div class="topnav-dropdown-header">
                              <span class="notification-title">Notifications</span>
                           </div>
                           <div class="noti-content">
                              <ul class="notification-list">
                                 <li class="notification-message">
                                    <a href="#">
                                       <div class="notify-block d-flex">
                                          <span class="avatar">
                                             <img class="avatar-img" alt="Ruby perin"
                                                src="assets/img/clients/client-01.jpg">
                                          </span>
                                          <div class="media-body">
                                             <h6>Travis Tremble <span class="notification-time">18.30 PM</span></h6>
                                             <p class="noti-details">Sent a amount of $210 for his Appointment <span
                                                   class="noti-title">Dr.Ruby perin </span></p>
                                          </div>
                                       </div>
                                    </a>
                                 </li>
                                 <li class="notification-message">
                                    <a href="#">
                                       <div class="notify-block d-flex">
                                          <span class="avatar">
                                             <img class="avatar-img" alt="Hendry Watt"
                                                src="assets/img/clients/client-02.jpg">
                                          </span>
                                          <div class="media-body">
                                             <h6>Travis Tremble <span class="notification-time">12 Min Ago</span></h6>
                                             <p class="noti-details"> has booked her appointment to <span
                                                   class="noti-title">Dr. Hendry Watt</span></p>
                                          </div>
                                       </div>
                                    </a>
                                 </li>
                                 <li class="notification-message">
                                    <a href="#">
                                       <div class="notify-block d-flex">
                                          <div class="avatar">
                                             <img class="avatar-img" alt="Maria Dyen"
                                                src="assets/img/clients/client-03.jpg">
                                          </div>
                                          <div class="media-body">
                                             <h6>Travis Tremble <span class="notification-time">6 Min Ago</span></h6>
                                             <p class="noti-details"> Sent a amount $210 for his Appointment <span
                                                   class="noti-title">Dr.Maria Dyen</span></p>
                                          </div>
                                       </div>
                                    </a>
                                 </li>
                                 <li class="notification-message">
                                    <a href="#">
                                       <div class="notify-block d-flex">
                                          <div class="avatar avatar-sm">
                                             <img class="avatar-img" alt="client-image"
                                                src="assets/img/clients/client-04.jpg">
                                          </div>
                                          <div class="media-body">
                                             <h6>Travis Tremble <span class="notification-time">8.30 AM</span></h6>
                                             <p class="noti-details"> Send a message to his doctor</p>
                                          </div>
                                       </div>
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </li>
                     <!-- /Notifications -->

                     <li class="nav-item" v-if="!isUser">
                        <a href="javascript:void(0)" v-on:click="GoTo('/login')"
                           class="btn btn-md btn-primary-gradient d-inline-flex align-items-center rounded-pill"><i
                              class="isax isax-lock-1 me-1"></i>Sign In</a>
                     </li>
                     <li class="nav-item" v-if="!isUser">
                        <a href="javascript:void(0)" @click="GoTo('/signup')"
                           class="btn btn-md btn-dark d-inline-flex align-items-center rounded-pill">
                           <i class="isax isax-user-tick me-1"></i>Register
                        </a>
                     </li>


                     <!-- User Menu -->
                     <li class="nav-item dropdown has-arrow logged-item" v-else>
                        <a href="#" class="nav-link ps-0" data-bs-toggle="dropdown">
                           <span class="user-img">
                              <img class="rounded-circle" src="assets/img/doctors-dashboard/profile-06.jpg" width="31"
                                 alt="Darren Elder">
                           </span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                           <div class="user-header">
                              <div class="avatar avatar-sm">
                                 <img src="assets/img/doctors-dashboard/profile-06.jpg" alt="User Image"
                                    class="avatar-img rounded-circle">
                              </div>
                              <div class="user-text">
                                 <h6>{{ name }}</h6>
                                 <p class="text-muted mb-0" v-if="roleName == 'Patient'">Patient</p>
                                 <p class="text-muted mb-0" v-if="roleName == 'Doctor'">Doctor</p>
                              </div>
                           </div>
                           <a class="dropdown-item" href="javascript:void(0)"
                              @click="GoTo('/dashboard')">Dashboard</a>
                           <a class="dropdown-item" href="javascript:void(0)" v-if="roleName == 'Doctor'"
                              @click="GoTo('/doctorProfileSetting')">Profile Settings</a>
                           <a class="dropdown-item" href="javascript:void(0)" v-if="roleName == 'Patient'"
                              @click="GoTo('/patientProfile')">Profile Settings</a>
                           <a class="dropdown-item" href="javascript:void(0)" @click="logout()">Logout</a>
                        </div>
                     </li>
                     <!-- /User Menu -->
                  </ul>
               </div>
            </nav>
         </div>
      </header>
      <!-- /Header -->

      <router-view :key="render" />

   </div>
</template>
<script>
export default {
   components: {

   },
   data() {
      return {
         isUser: false,
         hydrated: false,
         roleName: "",
         name: "",
         activeTab: '/',
         render: 0,
      }
   },
   methods: {
      GoTo: function (link) {
         this.render = this.render++;
         this.$router.push({
            path: `${link}`,
            query: {
               Add: true,
            }
         }).then(() => {
            if (link == '/dashboard' || link == '/patientProfile' || link == '/doctorProfileSetting') {
               window.location.reload();
            }
         });
      },
      setActiveTab(tab) {
         this.activeTab = tab;
         this.GoTo(tab); // Navigate to the route
      },
      logout: function () {
         var root = this;
         var url = '/account/logout';
         root.$https.post(url, this.login).then(function (response) {

            if (response.data == "Success") {
               root.$session.remove();
               localStorage.clear();
               window.location.href = '/';
            }
            else {
               root.$swal.fire(
                  {
                     icon: 'error',
                     title: 'Error Logging Out',

                  });
            }

         });

      },
   },
   created() {
      this.hydrated = true;
      const user = localStorage.getItem('IsUser') == "true" ? true : false;
      if (user) {
         this.isUser = localStorage.getItem('IsUser') == "true" ? true : false;
         this.roleName = localStorage.getItem('RoleName');
         this.name = localStorage.getItem('FullName');
      }

   }
}
</script>